import { Attribute, Directive, Input, OnInit, Optional } from '@angular/core';
import { DestroyedService } from 'app/shared/destroyed/destroyed.service';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CxUiComponentService } from '../cx-component.service';
import { CxUiConfigService } from '../cx-ui.config.service';
import { CxUiInputDateDateFormat, CxUiInputDateFirstDayOfWeek, CxUiInputDateLanguage, CxUiInputDateControlButtons, CxUiInputDateHideResetButton, cxUiInputDateLabelApply, cxUiInputDateLabelCancel } from './cx-input-date.config';
import { CwcInputDate } from '@cmx-web-components/angular';

@Directive({
  /* tslint:disable */
  selector: 'cwc-input-date',
  providers: [DestroyedService, CxUiComponentService],
})
export class CxInputDateProviderDirective implements OnInit {
  constructor(
    private cxUiComponent: CxUiComponentService<CwcInputDate>,
    private cxUiConfig: CxUiConfigService,

    private destroyed: DestroyedService,

    @Optional() @Attribute('date-format') private dateFormatAttribute?: CxUiInputDateDateFormat,
    @Optional() @Attribute('language') private languageAttribute?: CxUiInputDateLanguage,
    @Optional() @Attribute('first-day-of-week') private firstDayOfWeekAttribute?: CxUiInputDateFirstDayOfWeek,
    @Optional() @Attribute('control-buttons') private controlButtonsAttribute?: CxUiInputDateControlButtons,
    @Optional() @Attribute('hide-reset-button') private hideResetButtonAttribute?: CxUiInputDateHideResetButton,
    @Optional() @Attribute('label-apply') private labelApplyAttribute?: cxUiInputDateLabelApply,
    @Optional() @Attribute('label-cancel') private labelCancelAttribute?: cxUiInputDateLabelCancel,
  ) {
    this.cxUiComponent.hasSomeAttributeOf([
      dateFormatAttribute,
      languageAttribute,
      firstDayOfWeekAttribute,
      controlButtonsAttribute,
      hideResetButtonAttribute,
      labelApplyAttribute,
      labelCancelAttribute,
    ]);
  }

  @Input()
  public dateFormat?: CxUiInputDateDateFormat;

  @Input()
  public language?: CxUiInputDateLanguage;

  @Input()
  public firstDayOfWeek?: CxUiInputDateFirstDayOfWeek;

  @Input()
  public controlButtons?: CxUiInputDateControlButtons;

  @Input()
  public hideResetButton?: CxUiInputDateHideResetButton;

  @Input()
  public labelApply?: cxUiInputDateLabelApply;

  @Input()
  public labelCancel?: cxUiInputDateLabelCancel;

  public ngOnInit() {
    combineLatest([
      this.cxUiConfig.selectValueOf('dateFormat'),
      this.cxUiConfig.selectValueOf('dateLanguage'),
      this.cxUiConfig.selectValueOf('dateFirstDayOfWeek'),
      this.cxUiConfig.selectValueOf('dateControlButtons'),
      this.cxUiConfig.selectValueOf('dateHideResetButton'),
      this.cxUiConfig.selectValueOf('dateLabelApply'),
      this.cxUiConfig.selectValueOf('dateLabelCancel'),
    ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(([dateFormat, language, firstDayOfWeek, dateControlButtons, dateHideResetButton, dateLabelApply, dateLabelCancel]) => {
        if (this.dateFormat === undefined) {
          this.cxUiComponent.setProperty('dateFormat', this.dateFormatAttribute || dateFormat);
        }
        if (this.language === undefined) {
          this.cxUiComponent.setProperty('language', this.languageAttribute || language);
        }
        if (this.firstDayOfWeek === undefined) {
          this.cxUiComponent.setProperty('firstDayOfWeek', this.firstDayOfWeekAttribute || firstDayOfWeek);
        }
        if (this.controlButtons === undefined) {
          this.cxUiComponent.setProperty('controlButtons', this.controlButtonsAttribute || dateControlButtons);
        }
        if (this.hideResetButton === undefined) {
          this.cxUiComponent.setProperty('hideResetButton', this.hideResetButtonAttribute || dateHideResetButton);
        }
        if (this.labelApply === undefined) {
          this.cxUiComponent.setProperty('labelApply', this.labelApplyAttribute || dateLabelApply);
        }
        if (this.labelCancel === undefined) {
          this.cxUiComponent.setProperty('labelCancel', this.labelCancelAttribute || dateLabelCancel);
        }
      });
  }
}
